import React from 'react';

const LPFooter = () => (
  <footer className="bg-[#16231C] text-[#F9F8F6]/60 py-10">
    <div className="max-w-7xl mx-auto px-6 md:px-12 text-center">
      <p className="font-body text-sm">&copy; {new Date().getFullYear()} All rights reserved.</p>
      <div className="mt-4 flex items-center justify-center space-x-6 font-body text-sm">
        <a href="/privacy" className="hover:text-[#C85A40] transition-colors">Privacy Policy</a>
        <span className="text-[#F9F8F6]/20">|</span>
        <a href="/terms" className="hover:text-[#C85A40] transition-colors">Terms of Service</a>
      </div>
      <p className="mt-4 font-body text-xs text-[#F9F8F6]/40">Trademark registration services provided by licensed attorneys.</p>
    </div>
  </footer>
);

export default LPFooter;
